<template>
  <ModalStructure
    data-test-id="NoEligibleUsers"
    :showModal="showModal"
    showCloseButton
    @close="handleClose"
  >
    <template v-slot:header>
      <HeadingMedium>
        {{ title }}
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <ParagraphBody
        v-if="noEligibleUsersText"
      >
        <MarkdownInline
          data-test-id="NoEligibleUsers__noEligibleUsersText"
          :mdTemplate="noEligibleUsersText"
        />
      </ParagraphBody>
      <ParagraphBody
        v-if="sambaUserText"
      >
        <MarkdownInline
          data-test-id="NoEligibleUsers__sambaUserText"
          :mdTemplate="sambaUserText"
        />
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <Button
        text="Ok"
        @click="handleClose"
      />
    </template>
  </ModalStructure>
</template>

<script>
import {
  Button,
  HeadingMedium,
  MarkdownInline,
  ModalStructure,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { userStateActionMap, userStateActionType } from 'client/systemusers/constants/SystemUserConstants';
import EligibleUserMixin from 'client/systemusers/mixins/EligibleUserMixin';

export default {
  name: 'NoEligibleUsers',

  components: {
    Button,
    HeadingMedium,
    MarkdownInline,
    ModalStructure,
    ParagraphBody,
  },

  mixins: [EligibleUserMixin],

  props: {
    action: {
      type: String,
      default: undefined,
    },

    item: {
      type: Object,
      default: undefined,
    },

    showModal: Boolean,

    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    noEligibleUsersText() {
      let message = '';

      if (this.action) {
        const { noun } = userStateActionMap.get(this.action);
        const { suspend } = userStateActionType;

        // If this is the samba user on the aside, do not allow suspension
        if (this.isSambaUser && this.action === suspend) {
          message = `This user is not eligible for ${noun}.`;
        } else if (!this.item) {
          message = `**None** of the selected users are eligible for ${noun}.`;
        }
      }

      return message;
    },
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
